
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ISnapshotHypermediaRepresentation } from '../../shared/contracts/SnapshotContract';
import BounceInTransition from '../shared/BounceInTransition.vue';
import PeopleAction from './PeopleAction.vue';

@Component({
    components: {
        PeopleAction,
        BounceInTransition
    }
})

export default class PeopleActionCollection extends Vue {
    @Prop() snapshots: ISnapshotHypermediaRepresentation[];
}


